import { Nav, Navbar, NavItem } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import cn from 'classnames';

function SiteNavbar() {
  const location = useLocation();

  return (
    <Navbar className='p-0'>
      <Nav
        defaultActiveKey='/app/trips'
        className='sitenavbar-nav'
      >
        <NavItem
          className={cn(
            'sitenavbar-nav-item font-libre',
            location.pathname.includes('/app/trips') && 'active'
          )}
        >
          <a href='/app/trips'>My Trips</a>
        </NavItem>
        <NavItem
          className={cn(
            'sitenavbar-nav-item font-libre',
            location.pathname.includes('/app/bucket-list') && 'active'
          )}
        >
          <a href='/app/bucket-list'>Bucket List</a>
        </NavItem>
        <NavItem
          className={cn(
            'sitenavbar-nav-item font-libre',
            location.pathname.includes('/public-trips') && 'active'
          )}
        >
          <a href='/app/public-trips'>Public Trips</a>
        </NavItem>
        <NavItem
          className={cn(
            'sitenavbar-nav-item font-libre',
            location.pathname.includes('/app/discovery') && 'active'
          )}
          style={{ display: 'none' }}
        >
          <a href='/app/discovery'>Discovery</a>
        </NavItem>
        <NavItem
          className={cn(
            'sitenavbar-nav-item font-libre',
            location.pathname.includes('/app/feed') && 'active'
          )}
          style={{ display: 'none' }}
        >
          <a href='/app/feed'>Feed</a>
        </NavItem>
        <NavItem
          className={cn(
            'sitenavbar-nav-item font-libre',
            location.pathname.includes('/app/shared-with-me') && 'active'
          )}
        >
          <a href='/app/invitations'>Shared With Me</a>
        </NavItem>
      </Nav>
    </Navbar>
  );
}

export default SiteNavbar;
